import PieChartIcon from '@assets/icons-png/cropped_icons_with_padding/icon_49.png';
import PageContainer from "@components/layout/PageContainer";
import DashboarLinksSection, { DashboardLinksSectionProps } from "@components/content/DashboardLinksSection";
import ClientsReportOffCanvas from "@components/layout/Offcanvas/ClientsReportOffCanvas";
import { OpenClientsReportPubSub } from "@utils/pubsubs/PubSub";

const ClientsDashboard = () => {

  const groupLinks: DashboardLinksSectionProps[] = [
    {
      title: "Reportes Generales",
      links: [
        {
          icon: PieChartIcon,
          iconAlt: "Icono Reporte de Clientes",
          title: "Reporte de Clientes (Excel)",
          url: "#",
          onClick: () => {
            OpenClientsReportPubSub.publish({ openOffCanvas: true })
          }
        }
      ]
    }
  ]

  return (
    <PageContainer
      title="Reportes de Clientes"
      backUrl="/user/clients"
    >
      {
        groupLinks.map((gl, index) => {
          return (
            <DashboarLinksSection
              key={`group-${index}`}
              title={gl.title}
              links={gl.links}
            />
          )
        })
      }
      <ClientsReportOffCanvas />
    </PageContainer>
  );
}

export default ClientsDashboard;
